<img
	class="login-logo"
	src="{{ bhWebLogoUrl }}"
	data-cy="edassist-logo"
	alt="EdAssist by Bright Horizons Logo"
	title="Bright Horizons Logo"
/>
